module.exports = __webpack_public_path__ + "img/indah_logistik.093a79b3.png";